export default __webpack_public_path__ + "static/media/Apollo-Kullanim-Kilavuzu.fbdaaff8.pdf";